var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "mgv2__dropdown-button",
        class: _vm.categoryDropDownIsOpen
          ? "mgv2__dropdown--is-open"
          : "mgv2__dropdown--is-closed",
        on: {
          click: function ($event) {
            _vm.categoryDropDownIsOpen = !_vm.categoryDropDownIsOpen
          },
        },
      },
      [
        _c("span", { staticClass: "mgv2__dropdown-label" }, [
          _vm._v(_vm._s(_vm.selectedFirstLevelCategory)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "mgv2__dropdown-arrow" }),
      ]
    ),
    _vm._v(" "),
    !_vm.computedOnlyOneCategory
      ? _c(
          "ul",
          {
            staticClass: "mgv2__dropdown-choices",
            class: _vm.categoryDropDownIsOpen
              ? "mgv2__dropdown-choices--is-open"
              : "mgv2__dropdown-choices--is-closed",
          },
          _vm._l(_vm.computedFirstLevelTaxonomy, function (cat, index) {
            return _c("li", [
              _c(
                "a",
                {
                  key: index,
                  class: {
                    "mgv2__dropdown-choices--selected": cat.selectedLink,
                  },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectMainCategory(cat)
                    },
                  },
                },
                [_vm._v(_vm._s(cat.name))]
              ),
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.description.length > 0
      ? _c("div", { staticClass: "mgv2__description" }, [
          _c("p", [_vm._v(_vm._s(_vm.description))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.secondLevelTaxonomy.length > 0
      ? _c(
          "div",
          { staticClass: "mgv2__chips" },
          _vm._l(_vm.secondLevelTaxonomy, function (chip) {
            return _c("Chip", {
              key: chip.name,
              attrs: {
                label: chip.name,
                checked: chip.checked,
                parent: chip.parent,
              },
              on: { toggle: _vm.toggleChip },
            })
          }),
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mgv2__items" },
      _vm._l(
        _vm.filteredPosts.slice(0, _vm.computedPageRange),
        function (post, index) {
          return _c("section", { key: index, staticClass: "mgv2__item" }, [
            _c("picture", [
              _c("source", {
                attrs: { srcset: post.srcset, sizes: post.sizes },
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  loading: "lazy",
                  src: post.src,
                  width: post.width,
                  height: post.height,
                  sizes: post.sizes,
                  alt: post.alt,
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mgv2__item-content" }, [
              _c("div", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.getCategoryInformation(post.terms, 0)) +
                    " "
                ),
                _c("span", [_vm._v(" | ")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.getCategoryInformation(post.terms, 1))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mgv2__separator" }),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(post.title))]),
            ]),
            _vm._v(" "),
            _c("a", { attrs: { "aria-label": "", href: post.link } }),
          ])
        }
      ),
      0
    ),
    _vm._v(" "),
    _vm.computedShowMore
      ? _c("div", { staticClass: "mgv2__load-more" }, [
          _c(
            "a",
            {
              staticClass: "btn--quinary",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.loadMore.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(_vm.loadMoreText) + "\n        ")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }